/* eslint-disable no-dupe-keys */
// Material Dashboard 2 React base styles
import colors from 'assets/theme/base/colors';

const { gradients, dark } = colors;

function configs(labels, datasets) {
  // NOTE: commented for future use
  // const backgroundColors = [];

  // if (datasets.backgroundColors) {
  //   datasets.backgroundColors.forEach((color) =>
  //     gradients[color]
  //       ? backgroundColors.push(gradients[color].state)
  //       : backgroundColors.push(dark.main)
  //   );
  // } else {
  //   backgroundColors.push(dark.main);
  // }

  const getRandomColor = (totalCount) => {
    const colors = [];
    for (let i = 0; i < totalCount; i++) {
      colors.push('#' + Math.floor(Math.random() * 16777215).toString(16));
    }
    return colors;
  };

  return {
    data: {
      labels,
      datasets: [
        {
          label: datasets.label,
          weight: 9,
          cutout: 0,
          tension: 0.9,
          pointRadius: 2,
          borderWidth: 2,
          backgroundColor:
            datasets?.backgroundColors ??
            getRandomColor(datasets?.backgroundColors),
          fill: false,
          data: datasets.data,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          onClick: () => false,
        },
      },
      // NOTE: commented for future use

      // interaction: {
      //   intersect: false,
      //   mode: 'index',
      // },
      // scales: {
      //   y: {
      //     grid: {
      //       drawBorder: false,
      //       display: false,
      //       drawOnChartArea: false,
      //       drawTicks: false,
      //     },
      //     ticks: {
      //       display: false,
      //     },
      //   },
      //   x: {
      //     grid: {
      //       drawBorder: false,
      //       display: false,
      //       drawOnChartArea: false,
      //       drawTicks: false,
      //     },
      //     ticks: {
      //       display: false,
      //     },
      //   },
      // },
    },
  };
}

export default configs;
